import { Component, Input } from '@angular/core';
import { QuoteDetail } from '../../models/quote';
import { AppModule } from '../../app.module';

@Component({
  selector: 'app-quote-header',
  imports: [AppModule],
  templateUrl: './quote-header.html',
  styleUrl: './quote-header.less'
})
export class QuoteHeader {

  @Input() quote: QuoteDetail;

}
